export interface TaskInspirationLink {
  prompt: string;
  documentId?: string;
  familyRef?: string;
}

export const createTaskInspirationLink = ({
  prompt,
  documentId,
  familyRef,
}: TaskInspirationLink): string => {
  const baseUrl = "/tools/inspiration-hub";
  // const encodedPrompt = encodeURIComponent(prompt);
  // construct the url using URLSearchParams
  const searchParams = new URLSearchParams();
  searchParams.set("prompt", prompt);
  searchParams.set("autoRun", "1");
  if (documentId) {
    searchParams.set("documentId", documentId);
  }
  if (familyRef) {
    searchParams.set("family", familyRef);
  }
  return `${baseUrl}?${searchParams.toString()}`;
};

export const TASK_INSPO_WEEKLY_RECAP = {
  prompt: `Please populate this document template with updated information based on today's date and completed tasks from previous week. If there are no tasks that have been marked as done from the past week, you can include tasks that are in progress, but make sure to emphasize they are in progress.`,
  documentId: "9cd8fa30-5944-493b-9f96-a3e73363a84d",
};

export const TASK_INSPO_PERSONALIZED_TASKS = {
  prompt: `Please populate this document with tasks and ideas relevant to this family.

For seasonal -- Include task ideas that seem in line with what this family typically asks for, and/or what most families like theirs might want help in current season. This could be across home, travel, family, shopping, events, etc. Include at least 5 items. Don't suggest things we've talked about in the past 90 days.

For upcoming event support -- Look at their calendar or comms to see what events are after today, and come up with ideas of how the assistant could help. Include at least 5 items. Don't suggest things we've talked about in the past 90 days.

For recurring // annual tasks -- Look at past completed tasks at same time period the year before. Resurface here if relevant. If family has not been active long enough to have tasks from 12 months ago, share up to 5 common recurring tasks. Don't suggest things we've talked about in the past 90 days.

Avoid suggesting tasks that would require in-person help.`,
  documentId: "34cb2ba6-a97a-480c-a2dc-fcb884354759",
};

export const TASK_INSPO_FAMILY_DOSSIER_PATH = {
  prompt: `As you look at all the information about this particular family via comms, tasks, facts, notes, and events, can you create a dossier for me about the family?  Please use this template but use your intelligence to come up with additional facts that fit within the broader categories.

For missing details, do not suggest that additional children are missing if they've never mentioned additional children.`,
  documentId: "4c1d4bc7-f2c4-4025-adc4-1a4a4144198e",
};
